import React from 'react';
import { Tag, TagVariant } from '../../components/tag';
import type { ContestState } from '../../stores/contest';

export const CONTEST_STATES: Record<
    ContestState,
    { label: string; variant: TagVariant }
> = {
    draft: { label: 'Draft', variant: 'grey' },
    upcoming: { label: 'Upcoming', variant: 'blue' },
    running: { label: 'Running', variant: 'success' },
    ended: { label: 'Ended', variant: 'volcano' },
};

export const ContestStateTag = ({ state }: { state: ContestState }) => (
    <Tag variant={CONTEST_STATES[state].variant}>
        {CONTEST_STATES[state].label}
    </Tag>
);
